export default "__VITE_ASSET__BRp3qLgm__"